import { ColorTokenData } from "./color";
import { PageBlockAsset } from "./documentation-block-v1";
import { DocumentationItemHeaderAlignment, DocumentationItemHeaderAlignmentSchema, DocumentationItemHeaderImageScaleType, DocumentationItemHeaderImageScaleTypeSchema, } from "./item-header";
import { z } from "zod";
//
// Definitions
//
export const DocumentationItemHeaderV1 = z.object({
    description: z.string(),
    alignment: DocumentationItemHeaderAlignmentSchema,
    foregroundColor: ColorTokenData.nullish(),
    backgroundColor: ColorTokenData.nullish(),
    backgroundImageAsset: PageBlockAsset.nullish(),
    backgroundImageScaleType: DocumentationItemHeaderImageScaleTypeSchema,
    showBackgroundOverlay: z.boolean(),
    showCoverText: z.boolean(),
    minHeight: z.number().nullish(),
});
export const defaultDocumentationItemHeaderV1 = {
    alignment: DocumentationItemHeaderAlignment.Left,
    backgroundImageScaleType: DocumentationItemHeaderImageScaleType.AspectFill,
    description: "",
    showBackgroundOverlay: false,
    showCoverText: true,
};
